<!-- content.wxml -->
<template>
    <div class="contact-box">
        <!--  member  -->
        <div class="about-box skeleton-rect">
            <div class="title">关于我们</div>
            <div class="content">{{about}}</div>
        </div>
        <!--  member end -->
        <div class="divider-line"></div>
        <!-- contact -->
        <div class="contact-list">
            <div class="list-item clearfix">
                <div class="icon-box skeleton-rect">
                    <div class="iconfont icon-wenjian"></div>
                </div>
                <div class="content-box">
                    <div class="title skeleton-rect">联系电话/微信</div>
                    <div class="content skeleton-rect">{{tel}}</div>
                </div>
            </div>
            <div class="list-item clearfix">
                <div class="icon-box skeleton-rect">
                    <div class="iconfont icon-xiaoxi1"></div>
                </div>
                <div class="content-box">
                    <div class="title skeleton-rect">联系邮箱</div>
                    <div class="content skeleton-rect">{{email}}</div>
                </div>
            </div>
            <div class="list-item clearfix">
                <div class="icon-box skeleton-rect">
                    <div class="iconfont icon-dingwei1"></div>
                </div>
                <div class="content-box">
                    <div class="title skeleton-rect">联系地址</div>
                    <div class="content skeleton-rect">{{address}}</div>
                </div>
            </div>
        </div>
        <!-- contact end -->
    </div>
</template>
<script>
const  fakeDataUrl = '/api/banner/index'
import Tabber from '@/components/Tabber.vue'
export default {
    name: 'GoodsCategory',
    components: {
        Tabber
    },
    data () { //默认数据
        return {
            about : '艾易是一家以品牌策略、产品设计开发为切入点的实战咨询策划机构，致力于打破品牌营销瓶颈，以企业战略规划为支持，提供专业有效的品牌塑造服务，采用新思维手段，帮助企业解决品牌难题发挥品牌自身优势，创造更大的精神价值与市场价值。艾易始终秉承用市场回馈来验证艾易思维，依靠专业化口碑让更多客户选择艾易信赖艾易。我们把有限的精力全部花费在设计策划以及开发上靠专业和口碑吸引众多客户；艾易的客户遍布全球',
            tel : '13934878888',
            email: 'www.wuzi@163.com',
            address: '长春市 绿园区 新城吾悦广场 C座1251'
        }
    },
    created () { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('正在加载',{
            coverColor: "rgba(0,0,0,0.5)",
        });
    },
    mounted(){ //视图加载完成执行
        let _this = this;
        _this.axios.post(fakeDataUrl,_this.param).then((res) => {
            _this.loading.hide();
        }).catch((e) => {});
    },
    methods: { //页面方法
        // 切换分类
        
    },
    destroyed() {
        let _this = this;
　　　　//切记页面销毁需要销毁
　　}
}
</script>
<style lang="scss">
    @import "contact.scss";
</style>
